var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAdmin || _vm.isFromAuthUser)?_c('input',{staticClass:"form-control",staticStyle:{"min-width":"100px"},attrs:{"type":"number","placeholder":"avg burnrate"},domProps:{"value":(_vm.burnRate.rate / 100)},on:{"input":_vm.updateBurnRate}}):_c('div',{staticClass:"text-right",domProps:{"textContent":_vm._s((_vm.burnRate.rate / 100))}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f8de311","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/BurnRateInput.vue
// module id = z+p5
// module chunks = 0